// extracted by mini-css-extract-plugin
export default {"header":"ccf-app-header_header__bN-mC"};